/* nplus-deposit-service.js — endpoint resolution + deposit intent call + amount util.
   Classic script: exposes window.nplusDeposit. No dependencies. */
(function () {
  'use strict';

  var ZERO_DECIMAL = { bif:1,clp:1,djf:1,gnf:1,jpy:1,kmf:1,krw:1,mga:1,pyg:1,rwf:1,ugx:1,vnd:1,vuv:1,xaf:1,xof:1,xpf:1 };

  function toStripeAmount(amount, currency) {
    var cur = String(currency || '').toLowerCase();
    var n = parseFloat(amount);
    return ZERO_DECIMAL[cur] ? Math.round(n) : Math.round(n * 100);
  }

  // localhost/dev → window.__BACKEND_BASE + /create-deposit-intent; else App Proxy path.
  function resolveEndpoint() {
    var host = window.location.hostname;
    var isLocal = host === 'localhost' || host === '127.0.0.1';
    if (isLocal && window.__BACKEND_BASE) {
      return window.__BACKEND_BASE.replace(/\/$/, '') + '/create-deposit-intent';
    }
    return '/apps/nplus-deposit/create-deposit-intent';
  }

  function createDepositIntent(payload) {
    return fetch(resolveEndpoint(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) throw new Error(body && body.error ? body.error : 'deposit request failed');
        return body; // { clientSecret, customerId }
      });
    });
  }

  window.nplusDeposit = {
    toStripeAmount: toStripeAmount,
    resolveEndpoint: resolveEndpoint,
    createDepositIntent: createDepositIntent
  };
})();
